import React from 'react';
import { cn } from 'utils/cn';

export interface MessageBannerProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  variant?: 'error' | 'success' | 'warning';
}

const MessageBanner: React.FunctionComponent<MessageBannerProps> = ({ title, variant = 'success', className, ...props }) => {
  return title ? (
    <div
      className={cn(className, 'flex flex-row items-center justify-center rounded p-2 text-xs font-medium', {
        'bg-green-50 text-green-900': variant === 'success',
        'bg-slate-100 text-slate-500': variant === 'warning',
        'bg-red-50 text-red-900': variant === 'error' || !variant
      })}
      {...props}
    >
      {title}
    </div>
  ) : null;
};

export default MessageBanner;
